import React from 'react'

const EmailIntegration = () => {
  return (
    <div>EmailIntegration</div>
  )
}

export default EmailIntegration